











































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { MessageService } from "@/shared/services/message-service";

interface CentroItem {
  id: number;
  nombre: string;
}

interface ServicioItem {
  id: number;
  codigo: string;
  servicioLabel: string;
}

interface DoctorOption {
  value: number;
  label: string;
}

@Component({ name: "PublicAgendaTest" })
export default class PublicAgendaTest extends Vue {
  public centros: CentroItem[] = [];
  public servicios: ServicioItem[] = [];
  public doctorOptions: DoctorOption[] = [];

  public centroId: number | null = null;
  public codigoServicio: string = "";
  public selectedDoctorId: number | null = null;
  public fromInput: string = "";
  public toInput: string = "";
  public limit: number = 3;
  public waitSeconds: number = 25;

  public lastUrl: string = "";
  public lastResponse: any = null;

  public loadingCentros: boolean = false;
  public loadingServicios: boolean = false;
  public loadingDoctores: boolean = false;
  public loadingHuecos: boolean = false;
  public loadingProxima: boolean = false;
  public loadingPrimeras: boolean = false;

  public mounted() {
    this.fromInput = this.toLocalDateTimeInput(new Date());
    const plus7 = new Date();
    plus7.setDate(plus7.getDate() + 7);
    this.toInput = this.toLocalDateTimeInput(plus7);
    this.loadCentros();
  }

  public get prettyLastResponse(): string {
    if (this.lastResponse === null || this.lastResponse === undefined) return "-";
    try {
      return JSON.stringify(this.lastResponse, null, 2);
    } catch (e) {
      return String(this.lastResponse);
    }
  }

  public async loadCentros() {
    this.loadingCentros = true;
    try {
      const url = `${API.publicAgenda}/centros`;
      this.lastUrl = url;
      const res = await ssmHttpService.get(url, null, false);
      this.centros = Array.isArray(res)
        ? res.map((x: any) => ({ id: Number(x.id), nombre: x.nombre || `Centro ${x.id}` }))
        : [];
      this.lastResponse = res;
    } catch (error) {
      this.handleError("No se pudieron cargar los centros", error);
    } finally {
      this.loadingCentros = false;
    }
  }

  public async onCentroChanged() {
    this.codigoServicio = "";
    this.servicios = [];
    this.selectedDoctorId = null;
    this.doctorOptions = [];
    if (!this.centroId) return;
    await this.loadServicios();
  }

  public async loadServicios() {
    if (!this.centroId) {
      MessageService.alert("Validacion", "Selecciona un centro", MessageService.TypeWarning);
      return;
    }

    this.loadingServicios = true;
    try {
      const url = `${API.publicAgenda}/centros/${this.centroId}/servicios`;
      this.lastUrl = url;
      const res = await ssmHttpService.get(url, null, false);
      const rows = Array.isArray(res) ? res : [];
      this.servicios = rows.map((x: any) => ({
        id: Number(x.id),
        codigo: x.codigo_elegido || "",
        servicioLabel: `${x.servicio || "Servicio"} (${x.codigo_elegido || "sin_codigo"})`,
      }));
      this.lastResponse = res;
    } catch (error) {
      this.handleError("No se pudieron cargar los servicios", error);
    } finally {
      this.loadingServicios = false;
    }
  }

  public async testDoctores() {
    if (!this.ensureCentroServicio()) return;
    this.loadingDoctores = true;
    try {
      const query = this.buildQuery({ codigoServicio: this.codigoServicio, waitSeconds: this.waitSeconds });
      const url = `${API.publicAgenda}/centros/${this.centroId}/doctores${query}`;
      await this.execute(url);

      const response = this.lastResponse || {};
      const rows = Array.isArray(response.rows) ? response.rows : [];
      this.doctorOptions = rows
        .map((x: any) => ({
          value: Number(x.ID_Agenda),
          label: `${x.NombreDoctorAgenda || "Doctor"} (ID ${x.ID_Agenda})`,
        }))
        .filter((x: DoctorOption) => !isNaN(x.value))
        .sort((a: DoctorOption, b: DoctorOption) => a.label.localeCompare(b.label));
    } finally {
      this.loadingDoctores = false;
    }
  }

  public async testHuecos() {
    if (!this.ensureCentroServicio()) return;
    this.loadingHuecos = true;
    try {
      const query = this.buildQuery({
        doctorId: this.getDoctorIdOrNull(),
        from: this.getLocalDateTimeOrNull(this.fromInput),
        to: this.getLocalDateTimeOrNull(this.toInput),
        limit: this.limit,
        waitSeconds: this.waitSeconds,
      });
      const url = `${API.publicAgenda}/centros/${this.centroId}/servicios/${encodeURIComponent(this.codigoServicio)}/huecos${query}`;
      await this.execute(url);
    } finally {
      this.loadingHuecos = false;
    }
  }

  public async testProxima() {
    if (!this.ensureCentroServicio()) return;
    this.loadingProxima = true;
    try {
      const query = this.buildQuery({ from: this.getLocalDateTimeOrNull(this.fromInput), to: this.getLocalDateTimeOrNull(this.toInput), waitSeconds: this.waitSeconds });
      const url = `${API.publicAgenda}/centros/${this.centroId}/servicios/${encodeURIComponent(this.codigoServicio)}/proxima${query}`;
      await this.execute(url);
    } finally {
      this.loadingProxima = false;
    }
  }

  public async testPrimeras() {
    if (!this.ensureCentroServicio()) return;
    this.loadingPrimeras = true;
    try {
      const query = this.buildQuery({ from: this.getLocalDateTimeOrNull(this.fromInput), to: this.getLocalDateTimeOrNull(this.toInput), limit: this.limit, waitSeconds: this.waitSeconds });
      const url = `${API.publicAgenda}/centros/${this.centroId}/servicios/${encodeURIComponent(this.codigoServicio)}/primeras${query}`;
      await this.execute(url);
    } finally {
      this.loadingPrimeras = false;
    }
  }

  private ensureCentroServicio(): boolean {
    if (!this.centroId) {
      MessageService.alert("Validacion", "Selecciona un centro", MessageService.TypeWarning);
      return false;
    }
    if (!this.codigoServicio) {
      MessageService.alert("Validacion", "Selecciona un servicio", MessageService.TypeWarning);
      return false;
    }
    return true;
  }

  private async execute(url: string) {
    try {
      this.lastUrl = url;
      this.lastResponse = await ssmHttpService.get(url, null, false);
    } catch (error) {
      this.handleError("Error ejecutando endpoint", error);
    }
  }

  private handleError(message: string, error: any) {
    this.lastResponse = error;
    console.error(message, error);
    MessageService.alert("Error", message, MessageService.TypeError);
  }

  private getDoctorIdOrNull(): number | null {
    if (this.selectedDoctorId === null || this.selectedDoctorId === undefined) return null;
    return this.selectedDoctorId;
  }

  private getLocalDateTimeOrNull(input: string): string | null {
    const value = (input || "").trim();
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}T${this.pad(d.getHours())}:${this.pad(d.getMinutes())}:${this.pad(d.getSeconds())}`;
  }

  private buildQuery(params: any): string {
    const parts: string[] = [];
    Object.keys(params).forEach((k) => {
      const v = params[k];
      if (v === null || v === undefined || v === "") return;
      parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
    });
    return parts.length > 0 ? `?${parts.join("&")}` : "";
  }

  private toLocalDateTimeInput(d: Date): string {
    return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}T${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`;
  }

  private pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
  }
}
